import React, { useState, useMemo } from "react";
import {
    EffectComposer,
    Outline,
    Selection,
} from "@react-three/postprocessing";
import Landscape from "./Landscape.jsx";
import Billboard from "./Billboard.jsx";
import TimelineTrigger from "./TimelineTrigger.jsx";
import TimelinePortal from "../timeline/TimelinePortal.jsx";
import { Text, Float } from "@react-three/drei";
import { billboardData } from "../../model_data/billboard_data.js";
import { floatingTextData } from "../../model_data/floatingtext_data.js";

const pi = Math.PI;

export const Level = React.memo(function Level() {
    const [selectedObject, setSelectedObject] = useState(null);
    const [timelineVisible, setTimelineVisible] = useState(false);
    const [currentTimelineIndex, setCurrentTimelineIndex] = useState(0);

    // Outline Configurations
    const outlineConfig = useMemo(
        () => ({
            selection: selectedObject ? [selectedObject] : [],
            selectionLayer: 10,
            visibleEdgeColor: 0xffffff,
            edgeStrength: 5,
            pulseSpeed: 0,
            hiddenEdgeColor: 0x22090a,
            blur: 2,
            xRay: true,
        }),
        [selectedObject]
    );

    // Initialize each Billboard Component
    const billboards = useMemo(
        () =>
        billboardData.map((data, index) => (
            <Billboard
                key={index}
                modelPath={data.modelPath}
                position={data.position}
                scale={data.scale}
                rotation={data.rotation}
                contentType={data.contentType}
                onSelect={setSelectedObject}
            />
        )),
        [setSelectedObject]
    );

    // Create floating text elements
    const floatingTexts = useMemo(
        () =>
        floatingTextData.map((data, index) => (
            <Float
                key={`float-text-${index}`}
                position={data.position}
                rotation={data.rotation}
                speed={2.5}
                rotationIntensity={0.9}
                floatIntensity={1.6}
            >
            <Text
                color={data.color}
                fontSize={data.fontSize}
                anchorX="center"
                anchorY="middle"
                outlineWidth={0.02}
                outlineColor="black"
            >
                {data.text}
            </Text>
            </Float>
        )),
        []
    );

    return (
        <>
            <Selection>
                <EffectComposer multisampling={8} autoClear={false}>
                    <Outline {...outlineConfig} />
                </EffectComposer>
                {billboards}
            </Selection>
            
            {floatingTexts}
            <Landscape />

            {/* Timeline Components */}
            <TimelineTrigger
                onEnterTimeline={() => setTimelineVisible(true)}
                onExitTimeline={() => setTimelineVisible(false)}
            />
            <TimelinePortal
                isVisible={timelineVisible}
                currentIndex={currentTimelineIndex}
                onIndexChange={setCurrentTimelineIndex}
            />
        </>
    );
});
